let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../../utils/FormUtils");
let SlideOpenDown = require("../../../../widgets/SlideOpenDown");
let VerticalFields = require("ES/widgets/VerticalFields");
let rangeSelectIDs = require("./rangeSelectIDs");
let normalizeUsername = require("../../../../../utils/normalizeUsername");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let MultiItemEditModal = require("./MultiItemEditModal");
let EmailTemplatePreviewModal = require("./EmailTemplatePreviewModal");
let getUsernameOptions = require("./getUsernameOptions");
let EventFormUnsavedChangeMixin = require("../../EventFormUnsavedChangeMixin");
let getSpeakersFromDisplaylists = require("../../../../../utils/getSpeakersFromDisplaylists");

module.exports = dd.createClass({
  mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, "onFormChanged")],
  getInitialState() {
    return {
      id_delete_confirm: -1,
      field_editing: null,
      selected_item_ids: [],
      show_MultiItemEditModal: false,
      show_EmailTemplatePreviewModal: false,
      selectedEmailTemplate: null,
      column_sorting_by: "statusdate",
      column_sorting_ascending: true
    };
  },

  /**
   * use this method to ensure it's in sync with the availble EventTodo ids
   */
  __getSelectedItemsID() {
    let {event} = this.props;
    let {selected_item_ids} = this.state;

    return _.intersection(selected_item_ids, _.map(_.map(event && event.EventTodo, "id"), esUtils.toInt));
  },
  getInitialValues(props) {
    let {event} = props;
    return _.object(_.flatten(_.map(event && event.EventTodo, function (todo) {
      return [
        [todo.id + "_status", !!(todo.status > 0)],
        [todo.id + "_description", todo.description + ""],
        // somewhere in the code "null" values are being set to a literal string 'null', this check is a temporary fix
        [todo.id + "_email_recipient_group", todo.email_recipient_group === 'null' ? null :  todo.email_recipient_group + ''],
        [todo.id + "_actionforeignid", todo.action_foreign_id === 'null' ? null : todo.action_foreign_id + ""],
        [todo.id + "_actiontype", todo.action_type + ""],
        [todo.id + "_statusdate", _.isDate(todo.statusdate) ? todo.statusdate : null],
        [todo.id + "_assignedto", normalizeUsername(todo.assignedto)],
        [todo.id + "_vieworder", todo.vieworder]//invisible field that's used for the default table sorting
      ];
    })));
  },
  buildSchema() {
    let {event, read_only, Displaylists} = this.props;
    let username_options = getUsernameOptions(event);
    let speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));
    let eventContacts = event.EventContact;
    let speakerContactCodes = _.object(_.map(speaker && speaker.contactcodes, function (code) {
      return code;
    }));
    var sorted_options = [];
    _.each(eventContacts, function (contact){
      if(!_.isEmpty(contact.groupcodes)){
        _.each(contact.groupcodes, function (groupcode) {
          sorted_options.push({key: groupcode, value: "[" + groupcode + "] " + contact.cname});
        });
      }
    });
    _.each(speakerContactCodes, function(value, key) {
      let filtered_options = _.filter(sorted_options, function(option) {
        return option.key === key;
      });
      if(_.size(filtered_options) === 0) {
        sorted_options.push({key: key, value: "[" + key + "]"});
      }
    });

    sorted_options = _.object(_.map(sorted_options, function (item) {
      return [item.key, item.value];
    }));


    return _.object(_.flatten(_.map(event && event.EventTodo, function (todo) {
      return [
        [todo.id + "_status", {
          type: "checkbox",
          read_only,
          actionlist: todo
        }],
        [todo.id + "_description", {
          label: "Item description",//For the validation function
          type: "text"
        }],
        [todo.id + "_statusdate", {
          type: "date"
        }],
        [todo.id + "_assignedto", {
          type: "select",
          // We only show active users in the drop down, so if the selected option is inactive, also add it to the dropdown
          options: _.contains(username_options, _.get(todo, ["assignedto"])) ? username_options : _.assign({}, username_options, _.object([[_.get(todo, ["assignedto"]), _.get(todo, ["assignedto"])]])),
          placeholder: "--",
          validate: FormUtils.v.optional
        }],
        [todo.id + "_email_recipient_group", {
          type: "select",
          options: sorted_options,
          placeholder: "--",
          validate: FormUtils.v.optional
        }],
      ];
    })));
  },
  onFormChanged(field_path, new_value) {
    if (/_status$/.test(field_path) && !!new_value) {
      let todo_id = field_path.split("_")[0];
      let data = this.state.data || {};
      data[todo_id + "_statusdate"] = new Date();
      data[todo_id + "_assignedto"] = normalizeUsername(AuthedUserSession.MY_USERNAME);
      this.setState({data});
    }
    //from EventFormUnsavedChangeMixin
    this.__checkForChangesMade();
  },
  __resetForm: esUtils.wrapPreventDefault(function () {
    this.setState({id_delete_confirm: -1, field_editing: null});
    this.__discardChanges();//from EventFormUnsavedChangeMixin
  }),
  __setDeleteConfirmID(id) {
    let self = this;
    return esUtils.wrapPreventDefault(function () {
      self.setState({id_delete_confirm: id});
    });
  },
  __delete(id) {
    let self = this;
    return esUtils.wrapPreventDefault(function () {
      self.props.deleteItem(id);
    });
  },
  __setEditField(name) {
    return _.bind(esUtils.wrapPreventDefault(function (e) {

      let action_id = esUtils.toInt(/^([0-9]+)_/.exec(name)[1]);
      let is_multi_select = !!e.shiftKey;
      let is_single_select = !!(e.ctrlKey || e.metaKey || e.altKey);

      if (is_multi_select) {
        this.setState({
          field_editing: null,
          selected_item_ids: rangeSelectIDs(this.__getTodoIDsInOrder(), this.__getSelectedItemsID(), action_id)
        });
      } else if (is_single_select) {
        let selected_item_ids = this.__getSelectedItemsID();
        this.setState({
          field_editing: null,
          selected_item_ids: _.includes(selected_item_ids, action_id)
            ? _.without(selected_item_ids, action_id)
            : _.uniq([action_id].concat(selected_item_ids))
        });
      } else {
        this.setState({field_editing: this.props.read_only ? null : name, selected_item_ids: []});
      }
    }), this);
  },
  __toggleMultiItemEditModal: esUtils.wrapPreventDefault(function () {
    if (_.size(this.state.selected_item_ids) > 1) {
      this.setState({show_MultiItemEditModal: !this.state.show_MultiItemEditModal});
    }
  }),
  __toggleEmailTemplatePreviewModal(email_template) {
   let self = this;
    return esUtils.wrapPreventDefault(function (e) {
      // debugger;
      e.stopPropagation();
      self.setState({show_EmailTemplatePreviewModal: !self.state.show_EmailTemplatePreviewModal, selectedEmailTemplate: email_template});
    });
  },
  __clearMultiItem: esUtils.wrapPreventDefault(function () {
    this.setState({show_MultiItemEditModal: false, field_editing: null, selected_item_ids: []});
  }),
  __sortByColumn(column) {
    let self = this;
    return esUtils.wrapPreventDefault(function () {
      if (self.state.column_sorting_by === column) {
        self.setState({column_sorting_ascending: !self.state.column_sorting_ascending});
      } else {
        self.setState({column_sorting_by: column, column_sorting_ascending: true});
      }
    });
  },
  __findEmailTemplateById(id){
    let {event, Displaylists} = this.props;
    let speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));
    let email_templates = _.get(speaker, ['speaker_email_templates']);
    return _.first(_.filter(email_templates, function (template) {
      return parseInt(template.id, 10) === parseInt(id, 10);
    }));
  },
  __getTodoIDsInOrder() {
    let fields = this.Form_buildSchema();
    let initial_values = this.getInitialValues(this.props) || {};
    let {column_sorting_by, column_sorting_ascending} = this.state;

    let todo_ids = _.uniq(_.map(_.keys(fields), function (fieldname) {
      return esUtils.toInt(fieldname.split("_")[0]);
    }));
    todo_ids = _.sortBy(todo_ids, function (id) {
      let val = initial_values[id + "_" + column_sorting_by];
      return _.isString(val) ? val.toLowerCase() : val;
    });
    if (!column_sorting_ascending) {
      todo_ids = todo_ids.reverse();
    }
    return todo_ids;
  },
  render() {
    let self = this;
    let data = this.state.data || {};
    let errors = this.state.errors || {};
    let fields = this.Form_buildSchema();
    let changes_made = this.Form_areChangesMade();
    let selected_item_ids = this.__getSelectedItemsID();
    let {event, Displaylists} = this.props;
    let {show_MultiItemEditModal, show_EmailTemplatePreviewModal} = this.state;
    let used_contact_codes = [];
    _.each(event.EventContact, function (contact){
      if(!_.isEmpty(contact.groupcodes)){
        _.each(contact.groupcodes, function (groupcode) {
          used_contact_codes.push(groupcode);
        });
      }
    });

    let renderFieldCell = function (field_name, children) {
      let field = fields[field_name];
      let error = errors[field_name];

      let body = null;
      let width = null;
      let onClick = null;
      let classes = [];

      if (self.state.field_editing === field_name || field.type === "checkbox") {
        body = self.Form_buildInput(field);
        if (field.type === "date") {
          width = "11em";
        } else if (field.type === "select") {
          width = "9em";
        }
      } else {
        body = _.isDate(data[field_name]) ? esUtils.format_date(data[field_name], "mm/dd/yyyy") : (data[field_name] || "--");
        onClick = self.__setEditField(field_name);
      }
      if (field.type === "checkbox") {
        classes.push("text-center");
      }
      if (error) {
        classes.push("has-error");
      }
      return dd.td({className: classes.join(" "), style: {width: width}, onClick: onClick, onContextMenu: self.__toggleMultiItemEditModal},
        body,
        children,
        error ? dd.span({className: "help-block"}, error) : null
      );
    };

    let today = new Date();

    return dd.div(null,
      //this modal needs to be rendered outside the form or else the modals submit button will submit the parent form
      show_MultiItemEditModal
        ? MultiItemEditModal({
          event,
          Displaylists,
          selected_item_ids,
          onClose: this.__toggleMultiItemEditModal,
          onClearMultiItem: this.__clearMultiItem
        })
        : null,
      show_EmailTemplatePreviewModal
        ? EmailTemplatePreviewModal({
          onClose: this.__toggleEmailTemplatePreviewModal,
          email_template: this.state.selectedEmailTemplate,
        })
        : null,
      dd.form({className: "ActionListTable", onSubmit: this.Form_onSubmit},
        dd.table({className: "table table-condensed table-hover"},
          dd.thead(null,
            dd.tr(null,
              _.map([
                {sort_field: "status", width: 1},
                {sort_field: "description", label: "Item"},
                {sort_field: "statusdate", label: "Date"},
                {sort_field: "assignedto", label: "By"}
              ], function (col, i) {
                return dd.th({key: i, className: "clickable no-select", style: {width: col.width || null}, onClick: self.__sortByColumn(col.sort_field)},
                  col.label || null,
                  " ",
                  self.state.column_sorting_by === col.sort_field ? dd.i({className: "fa fa-caret-" + (self.state.column_sorting_ascending ? "down" : "up")}) : null
                );
              }),
              this.props.read_only ? null : dd.th(null, "")
            )
          ),
          dd.tbody(null,
            _.map(this.__getTodoIDsInOrder(), function (todo_id) {
              let confirm_delete = todo_id == this.state.id_delete_confirm;
              let classes = ["no-select"];
              if (data[todo_id + "_status"]) {
                classes.push("success");
              } else if (_.isDate(data[todo_id + "_statusdate"]) && (today.getTime() >= data[todo_id + "_statusdate"].getTime())) {
                classes.push("danger");//over due
              }
              if (confirm_delete) {
                classes.push("danger");
              }
              if (_.includes(selected_item_ids, esUtils.toInt(todo_id))) {
                classes.push("selected");
              }
              if(parseInt(data[todo_id + "_actiontype"], 10) === 1){
                let warn_contact_code = false;
                if(!_.includes(used_contact_codes, data[todo_id + '_email_recipient_group'])){
                  warn_contact_code = true;
                }
                return dd.tr({key: todo_id, className: classes.join(" ")},
                  renderFieldCell(todo_id + "_status"),
                  renderFieldCell(todo_id + "_description",
                    this.state.field_editing === todo_id + "_description"
                      ?
                      dd.div(null,
                        dd.p({
                            className: 'text-muted',
                            onClick: this.__toggleEmailTemplatePreviewModal(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]))
                          },
                          _.get(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]), ['name']) + " ",
                          dd.a({href: '#'}, dd.i({className: 'fa fa-eye text-link'}))
                        )) :
                    dd.span(null,
                      dd.i({className: 'fa fa-envelope text-muted', style:{marginLeft: '3px'}}),
                    dd.div(null,
                      dd.p({
                        className: 'text-muted',
                        onClick: this.__toggleEmailTemplatePreviewModal(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]))
                      },
                      _.get(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]), ['name']) + " ",
                      dd.a({href: '#'}, dd.i({className: 'fa fa-eye text-link'}))
                    )))
                  ),
                  confirm_delete ? null : renderFieldCell(todo_id + "_statusdate"),
                  confirm_delete ? null : renderFieldCell(todo_id + "_email_recipient_group", warn_contact_code && dd.i({className: 'fa fa-warning text-warning', style: {marginLeft: '3px'}})),
                  confirm_delete || this.props.read_only ? null : dd.td(null,
                    dd.a({href: '#', onClick: this.__setDeleteConfirmID(todo_id)}, dd.i({className: "fa fa-times"}))
                  ),
                  confirm_delete ? dd.td({colSpan: 3, style: {width: "auto", textAlign: "right"}},
                    dd.button({className: "btn btn-sm btn-danger", onClick: this.__delete(todo_id)}, "Delete"),
                    " ",
                    dd.button({className: "btn btn-sm btn-default", onClick: this.__setDeleteConfirmID(-1)}, "Cancel")
                  ) : null
                );
              }
              return dd.tr({key: todo_id, className: classes.join(" ")},
                renderFieldCell(todo_id + "_status"),
                renderFieldCell(todo_id + "_description", this.state.field_editing === todo_id + "_description" ? null
                  :
                  dd.span(null,
                    dd.i({className: 'fa fa-bell text-muted', style:{marginLeft: '3px'}})
                  )
                ),
                confirm_delete ? null : renderFieldCell(todo_id + "_statusdate"),
                confirm_delete ? null : renderFieldCell(todo_id + "_assignedto"),
                confirm_delete || this.props.read_only ? null : dd.td(null,
                  dd.a({href: "#", onClick: this.__setDeleteConfirmID(todo_id)}, dd.i({className: "fa fa-times"}))
                ),
                confirm_delete ? dd.td({colSpan: 3, style: {width: "auto", textAlign: "right"}},
                  dd.button({className: "btn btn-sm btn-danger", onClick: this.__delete(todo_id)}, "Delete"),
                  " ",
                  dd.button({className: "btn btn-sm btn-default", onClick: this.__setDeleteConfirmID(-1)}, "Cancel")
                ) : null
              );
            }, this)
          )
        ),
        _.size(selected_item_ids) > 1
          ? dd.button({className: "btn btn-default btn-sm pull-right", onClick: this.__toggleMultiItemEditModal},
          dd.i({className: "fa fa-edit"}), " Change ", _.size(selected_item_ids), " items"
          )
          : null,
        SlideOpenDown({open: changes_made},
          VerticalFields.FormButtons({onDiscard: this.__resetForm})
        )
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/ActionListTable.js